import { Grid2, useMediaQuery } from "@mui/material";

import Header from "../../Common/Header";
import OurFeaturedProductsMsite from './MobileView/OurFeaturedProductsMsite'
import MainContent from "./Webview/MainContent";

const OurProducts = () => {
  const isSmallScreen = useMediaQuery('(max-width:480px)')
  return (
    <Grid2 >
        <Header />
        {isSmallScreen ? <OurFeaturedProductsMsite /> : <MainContent />}
    </Grid2>
  )
}

export default OurProducts
